<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  $margin-left-right: utils.in_rem(24px);

  .text-input {
    padding: utils.in_rem(24px);
    width: utils.in_rem(400px);
  }

  .footer {
    width: calc(100% - 2 * $margin-left-right);
    display: flex;
    justify-content: flex-end;
    padding: utils.in_rem(12px) 0;
    gap: utils.in_rem(16px);
    margin: 0 $margin-left-right;
    border-top: 1px solid colors.get(interfaceSwGrey_10);
  }
</style>

<script>
  // Svelte
  import { getContext } from "svelte";
  // Functions
  import { showToast } from "@sourcewhale/core";
  import { logNote } from "../../../../../api/notes";
  // Components
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import TextInput from "@sourcewhale/shared/svelte-design-system/components/molecules/InputFields/TextInput.svelte";
  import Modal from "@sourcewhale/shared/svelte-design-system/components/molecules/Modal/Modal.svelte";
  // Context
  import { CONTACT_CTAS_CONTEXT } from "../context";

  // Get store from context
  const { activePopUpModalStore, activityFeedStore, candidateStore } =
    getContext(CONTACT_CTAS_CONTEXT);

  export let kind = "";
  export let label = "";

  let content;

  const confirm = () => {
    activePopUpModalStore.set(null);
    activityFeedStore.get(); // Refresh the activity feed to see new note
  };

  const cancel = () => {
    activePopUpModalStore.set(null);
  };

  const wrappedConfirm = async () => {
    const body = {
      candidateId: $candidateStore.candidateId,
      content,
      kind,
    };
    return logNote(body).then(() => {
      showToast({
        title: `Success!`,
        subtitle: `Note saved.`,
        type: "success",
      });
      confirm();
    });
  };
</script>

<Modal onclose={cancel} blur="4px" closeButton={false}>
  <div slot="header">
    <h2>Log {["SMS", "Interview"].includes(label) ? "an" : "a"} {label}</h2>
  </div>
  <div class="text-input">
    <TextInput
      kind="textarea"
      placeholder="Note content"
      bind:value={content}
      autoFocus={true}
    />
  </div>
  <div class="footer">
    <Button class="flex-1" onclick={cancel} kind="ghost-blue">Cancel</Button>
    <Button
      class="flex-1 {content ? '' : 'disabled'}"
      onclick={() => (content ? wrappedConfirm() : "")}>Ok</Button
    >
  </div>
</Modal>
